import React, { useState } from "react";
import { Toggle } from "../shared";
import { toast } from "react-hot-toast";

const HEX_RE = /^0x[0-9a-fA-F]{40}$/;

export default function AddressRules({ config, onUpdate, disabled }) {
  const [addressInput, setAddressInput] = useState("");

  const blocklist = config?.blocklist || [];
  const allowlist = config?.allowlist || [];
  const blocklistEnabled = config?.blocklistEnabled ?? false;
  const allowlistOnly = config?.allowlistOnly ?? false;

  const handleAddAddress = (type) => {
    const addr = addressInput.trim();
    if (!HEX_RE.test(addr)) {
      toast.error("Invalid Ethereum address format");
      return;
    }
    const list = type === "block" ? [...blocklist, addr] : [...allowlist, addr];
    onUpdate({
      [type === "block" ? "blocklist" : "allowlist"]: list,
    });
    setAddressInput("");
  };

  const handleRemoveAddress = (type, addr) => {
    const list =
      type === "block"
        ? blocklist.filter((a) => a !== addr)
        : allowlist.filter((a) => a !== addr);
    onUpdate({
      [type === "block" ? "blocklist" : "allowlist"]: list,
    });
  };

  return (
    <div className={`mcp-address-rules ${disabled ? "mcp-disabled-section" : ""}`}>
      <h5 className="mcp-subsection-title">Address rules</h5>

      <div className="mcp-address-toggles">
        <Toggle
          label="Enable blocklist"
          checked={blocklistEnabled}
          onChange={(val) => onUpdate({ blocklistEnabled: val })}
          disabled={disabled}
        />
        <Toggle
          label="Allowlist-only mode"
          checked={allowlistOnly}
          onChange={(val) => onUpdate({ allowlistOnly: val })}
          disabled={disabled}
        />
      </div>

      {/* Add address input */}
      <div className="mcp-address-input-row">
        <input
          type="text"
          className="mcp-text-input"
          value={addressInput}
          onChange={(e) => setAddressInput(e.target.value)}
          placeholder="0x..."
          disabled={disabled}
        />
        <button
          type="button"
          className="mcp-btn mcp-btn-sm"
          onClick={() => handleAddAddress(blocklistEnabled ? "block" : "allow")}
          disabled={disabled || !addressInput.trim()}
        >
          Add
        </button>
      </div>

      {/* Blocked addresses */}
      {blocklistEnabled && blocklist.length > 0 && (
        <div className="mcp-address-list">
          <label className="mcp-field-label">Blocked addresses</label>
          <div className="mcp-chip-list">
            {blocklist.map((addr) => (
              <span key={addr} className="mcp-chip mcp-chip-red">
                {addr.slice(0, 8)}...{addr.slice(-4)}
                <button
                  type="button"
                  onClick={() => handleRemoveAddress("block", addr)}
                  disabled={disabled}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Allowed addresses */}
      {allowlistOnly && allowlist.length > 0 && (
        <div className="mcp-address-list">
          <label className="mcp-field-label">Allowed addresses</label>
          <div className="mcp-chip-list">
            {allowlist.map((addr) => (
              <span key={addr} className="mcp-chip mcp-chip-green">
                {addr.slice(0, 8)}...{addr.slice(-4)}
                <button
                  type="button"
                  onClick={() => handleRemoveAddress("allow", addr)}
                  disabled={disabled}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
